import Components from './component'
import { makeInstaller } from './make-installer'

export default makeInstaller([...Components])
